export default function RowActionButton({
    label,
    onClick,
    icon: Icon,
    danger = false,
}) {
    return (
        <button
            type="button"
            className={danger ? "danger" : undefined}
            aria-label={label}
            onClick={onClick}
        >
            <Icon size={16} aria-hidden="true" />
        </button>
    );
}
